import { ModalId } from '@heidi/schema/ml-scribe';

import { MODAL_PRIORITY, type QueuedModalDescriptor } from './hcp-verification-ports';

/**
 * Queue id of the clinician (NPI) verification dialog. The weekly launch row,
 * the account-settings CTAs and the inmail row all open the same
 * `useQueuedModal` shell, so every close stamps one `seen_modals` record and
 * the 7-day cooldown in `modalClosedRules` reads one `last_seen_at`.
 */
export const HCP_VERIFICATION_MODAL_ID =
  ModalId.CUSTOM_AUDIENCE_HCP_VERIFICATION_REMINDER_MODAL;

/**
 * Settings CTA / inmail open. CRITICAL so a deliberate open is not parked
 * behind whatever launch modal is on stage.
 */
export const HCP_VERIFICATION_OPEN_QUEUE_ITEM: QueuedModalDescriptor = {
  id: HCP_VERIFICATION_MODAL_ID,
  priority: MODAL_PRIORITY.CRITICAL,
  dismissible: true,
  showOnce: false,
};

/**
 * Pin the shell adds for itself once the launch row puts the dialog on stage,
 * so an eligibility flip cannot unmount it mid-flow. HIGH mirrors the launch
 * row: a pin holds the stage, it must not promote the dialog past modals
 * ranked above it. The priority also tells the two doors apart — CRITICAL is a
 * deliberate open and is left alone, HIGH is the reminder and stands down when
 * a consult starts. `enqueueModalAtom` keeps the first write per id, so
 * neither entry can overwrite the other.
 */
export const HCP_VERIFICATION_PIN_QUEUE_ITEM: QueuedModalDescriptor = {
  id: HCP_VERIFICATION_MODAL_ID,
  priority: MODAL_PRIORITY.HIGH,
  dismissible: true,
  showOnce: false,
};
